<template>
  <div class="media-results">
    <ItemResultDefault
      v-for="(item, index) in items"
      :key="index"
      :item="item"
      :domain-name="domainName"
      @more="$emit('more', ...arguments)"
    />
  </div>
</template>

<script>
import ItemResultDefault from './ItemResultDefault.vue'
import { expBus } from '@js-packages/experiment-loader'
import { getBetterQualities } from '../tools/betterQualities'

export default {
  name: 'ResultDefault',
  components: { ItemResultDefault },
  props: {
    data: {
      type: [Array, Object],
      required: true
    },
    domainName: String
  },
  mounted() {
    // Компонент монтируется заново на каждую выдачу (v-if в LinkAnalyzerView) — один эмит на выдачу,
    // после того как кнопки .link-box уже в DOM.
    this.$nextTick(() => {
      const betterQuality = getBetterQualities(this.items[0])
      if (betterQuality) {
        expBus.emit('tzBestQuality', betterQuality)
      }
    })
  },
  computed: {
    items() {
      return Array.isArray(this.data) ? this.data : [this.data]
    }
  }
}
</script>
